export const getAllFirmwareData = state => state.entries.firmware.data
export const getFirmwareData = (state, deviceId) => getAllFirmwareData(state)[deviceId]

export const getAllFirmwareUpdateStatus = state => state.entries.firmware.updateStatus
export const getFirmwareUpdateStatus = (state, deviceId) => getAllFirmwareUpdateStatus(state)[deviceId]
